// extracted by mini-css-extract-plugin
module.exports = {"views":"views_views__PKB_T","primary":"views_primary__TyLhX","secondary":"views_secondary__coCWn"};